// Mock data for RentKollect clone

export const stats = [
  {
    id: 1,
    icon: 'Building2',
    label: 'Property',
    value: '15,000+'
  },
  {
    id: 2,
    icon: 'DoorOpen',
    label: 'Rooms',
    value: '3 Lacs+'
  },
  {
    id: 3,
    icon: 'Users',
    label: 'Tenants',
    value: '2.3 Lacs+'
  },
  {
    id: 4,
    icon: 'IndianRupee',
    label: 'Collection',
    value: '100 Cr+'
  }
];

export const propertyTypes = [
  { id: 1, name: 'Co-Living', icon: 'Building' },
  { id: 2, name: 'Hostel/PG', icon: 'Home' },
  { id: 3, name: 'Flat', icon: 'Building2' },
  { id: 4, name: 'Studio', icon: 'Hotel' }
];

export const trustedClients = [
  'Book My Bed', 'AHPL Hostels', 'Brainway Stay', 'Narenn Living',
  'Covie Living', 'Lokhith Residency', 'Oxotel Living', 'Prustel Living',
  'Cohousy', 'Alliance Homes', 'Stay 126', 'The Fab Hostels',
  'Livesta', 'Conest', 'Uptown Smart Hostel', 'Jeet House'
];

export const testimonials = [
  {
    id: 1,
    text: 'Hum log payment se lekar, Koi bhi notification dena ho hume complaints bhi dekhni ho sab yhi se ho jata hai. Isi app ki wajah se hume desh bhar se leads aa rhi hai or app ki wajh se hi logo ko secure and trusted feel hota hai.',
    name: 'Mr. Sandeep Rajkowa',
    duration: 'Using RentKollect since last 16 months'
  },
  {
    id: 2,
    text: 'This is a perfect platform which really gonna help landlord and as well as tenants because they feel more secure by getting an agreement with a landlord with this app.',
    name: 'Mr. Rohit Tandon',
    duration: 'Using RentKollect since last 25 months'
  },
  {
    id: 3,
    text: 'Pahle mujhe customer ko deal karne mein bhut jayada dikkat aati thi. Rooms nahi clear hote the kon sa khali hai kon sa bhara hai, Rent collection mein dikkat aati thi. Or Jab se meine RentKollect app use krna start kia hai tab se mein tension free rhta hu.',
    name: 'Mr. Bhavinder Singh',
    duration: 'Using RentKollect since last 18 months'
  }
];

export const features = [
  {
    id: 1,
    title: 'Convert your leads into booking. 10X Faster!',
    subtitle: 'Why wait 2 months to fill your rooms? Get tenants 10X Faster',
    points: [
      'Share location & Follow Up on WhatsApp in One-click',
      'Update real-time Lead Status & Schedule Visit',
      'Assign Leads to properties and staff',
      'Collect Token With Whatsapp Payment link & QR'
    ]
  },
  {
    id: 2,
    title: 'Get your Property website. Market it online & Offline',
    subtitle: 'No more repeating the same thing 20 times a day. Less Calls; More conversion',
    points: [
      'Show off your own website to everyone & on Google',
      'Automatic update of facilities, occupancy, photos & Rent',
      'Accept Video Calls & Schedule Visits from your website',
      'Get Token payment with "Reserve Bed" option'
    ]
  },
  {
    id: 3,
    title: '100% Automatic Rent & Due Collection. 5 days max!',
    subtitle: 'No more calls. No more running after tenants. No more jhikjhik',
    points: [
      'Automatic monthly Rent & Bill addition',
      'Automatic payment reminders on WhatsApp, SMS & Notification',
      'One-click Bulk WhatsApp reminder with Payment Link',
      'Automatic Late Fine addition after the grace period'
    ]
  },
  {
    id: 4,
    title: '24/7 Digital Accountant at your fingertips',
    subtitle: '✅ Accounting Done ✅ Reports Done +7 more reports',
    points: [
      'Real-time transaction updates on App & WhatsApp',
      'Excel Reports of Dues, Income, Expense, Lead, Tenant, Profit-Loss',
      'Category & Month filters on dues, collection & expenses in app',
      'UTR no. directly in the app. No need to check the bank account'
    ]
  },
  {
    id: 5,
    title: 'All Tenant details in one place',
    subtitle: 'From Joining Form to Police Verification. Payment History to Tenant Ledger',
    points: [
      'Contactless Check-in for new tenants like 5-star hotels',
      'Tenant\'s Personal, Parents & Renting details in one place',
      'Digital KYC & Verify or Reject Tenant\'s Documents & Govt. IDs',
      'Shift tenants from one room or property to another'
    ]
  },
  {
    id: 6,
    title: 'Your Floor Plan in Your Smartphone',
    subtitle: 'Occupied or Under Notice? Single Sharing or Double Sharing? With or Without AC? No need to remember. No Confusion.',
    points: [
      'Add & view floor plan of your property on phone',
      'Real-time update of filled, vacant, under notice rooms & beds',
      'Track room sharing types, rent, facilities & photos in one place',
      'Allot or block Room & bed in one click'
    ]
  }
];

export const tenantBenefits = [
  {
    id: 1,
    icon: 'Gift',
    title: 'Surprise Birthday Gift',
    description: 'Free Gift worth upto ₹1000 in tenant\'s birthday month'
  },
  {
    id: 2,
    icon: 'Shield',
    title: 'Personal Accidental Insurance',
    description: 'Get Rs 1 lac of personal accidental cover for 1 year'
  },
  {
    id: 3,
    icon: 'Award',
    title: 'Assured Rent Rewards',
    description: 'Exclusive rent rewards every month on timely rent payment'
  },
  {
    id: 4,
    icon: 'Activity',
    title: 'Live fitness and Zumba class',
    description: 'Get fit with live fitness and zumba classes and join from anywhere'
  },
  {
    id: 5,
    icon: 'Heart',
    title: 'Health Benefits',
    description: 'Get health benefits of hospitalization cover and 24/7 doctor on call'
  },
  {
    id: 6,
    icon: 'Percent',
    title: 'Get 50% Cashback',
    description: 'On Debit, Credit & Netbanking payment processing charges'
  }
];

export const blogs = [
  {
    id: 1,
    title: 'Cloud Based Rental Property Management Software vs. Local',
    excerpt: 'Cloud Based Rental Property Management Software vs. Local Property management has changed significantly over the past few years...',
    author: 'Ishika Pannu',
    date: '04 Apr 2026',
    image: 'blog-1'
  },
  {
    id: 2,
    title: 'All-in-One Property Management Software: Is It Worth It?',
    excerpt: 'Property management today is no longer limited to collecting rent and filling vacancies...',
    author: 'Ishika Pannu',
    date: '04 Apr 2026',
    image: 'blog-2'
  },
  {
    id: 3,
    title: 'Creating a Better Living Experience with a PG App',
    excerpt: 'Running a PG today is not just about providing accommodation. It\'s about delivering a smooth, organized experience...',
    author: 'Ishika Pannu',
    date: '03 Apr 2026',
    image: 'blog-3'
  }
];

export const newsItems = [
  {
    id: 1,
    title: 'Eqaro Guarantees join hands with RentKollect',
    description: 'Eqaro Guarantees, a technology led financial guarantees company, announced its partnership with RentKollect...',
    source: 'Times of India',
    date: '28 Mar 2023'
  },
  {
    id: 2,
    title: 'RentKollect (formerly EazyPG) on surviving 2020',
    description: 'How the young and restless teams dealt with the Covid-19 standstill',
    source: 'Forbes India',
    date: '11 Feb 2021'
  },
  {
    id: 3,
    title: 'RentKollect selected as one of the top 10 startups',
    description: 'Lightspeed Extreme Entrepreneurs 2019 programme',
    source: 'Lightspeed India',
    date: '03 Sep 2019'
  }
];

export const insuranceFeatures = [
  { id: 1, icon: 'Flame', name: 'Fire & Short Circuit' },
  { id: 2, icon: 'AlertTriangle', name: 'Riots & Explosion' },
  { id: 3, icon: 'Wind', name: 'Storms & Cyclones' },
  { id: 4, icon: 'Droplets', name: 'Flood & Inundation' },
  { id: 5, icon: 'Lock', name: 'Burglaries' },
  { id: 6, icon: 'Mountain', name: 'Earthquake & Landslides' }
];

export const digitalFeatures = [
  { id: 1, text: 'Digital check-in & KYC' },
  { id: 2, text: 'Online Rent Payment & Receipt' },
  { id: 3, text: 'Rent Rewards & Cashback' },
  { id: 4, text: 'In app food menu' },
  { id: 5, text: 'Faster Complaint Resolution' },
  { id: 6, text: 'Move into different properties' }
];
